import { useNavigate } from 'react-router-dom';
import { useSession } from '../../app/session';
import { CRM_URL } from '../../config';
import { useT } from '../../i18n';

/** A staff user of the sponsor logged in here: explain and send them to the CRM. Their session is already closed. */
export function NotPartnerPage() {
  const t = useT();
  const nav = useNavigate();
  const expire = useSession((s) => s.expire);
  const crm = CRM_URL || '/';
  return (
    <div className="page min-h-[100dvh] pt-[max(32px,env(safe-area-inset-top))]">
      <div className="card" role="alert">
        <h1>{t('notPartner.title')}</h1>
        <p className="mt-3 text-[16px] text-txt">{t('notPartner.body')}</p>
        <a href={crm} className="btn-primary mt-5 min-h-big w-full text-[18px]">
          {t('notPartner.crm')}
        </a>
        <button
          type="button"
          className="btn mt-3 w-full"
          onClick={() => {
            expire();
            nav('/login', { replace: true });
          }}
        >
          {t('notPartner.other')}
        </button>
      </div>
    </div>
  );
}
